// Translate
<template>
  <CalendarSearchBarButton
    id="charterButtonDuration"
    ref="charterButtonDuration"
    :active="active"
    :loading="loading"
    data-i18n="charterSearchPeriodDay|charterSearchDuration|charterSearchSelect|charterSearchCustomDuration|charter.duration.week"
    @click="$emit('setActive')"
  >
    <template #icon>
      <fa :icon="icons.faCalendarClock" />
    </template>
    <template #label>
      <span data-i18n="charterSearchDuration">
        {{ $t('charterSearchDuration') }}
      </span>
    </template>
    <template #content>
      <span v-if="!selectedDuration.value && selectedDuration.type !== 'custom'">
        {{ $t('charterSearchSelect') }}
      </span>
      <span v-else>
        {{ displayDuration }}
      </span>
    </template>
  </CalendarSearchBarButton>
</template>

<script>
import { faCalendarClock } from '@fortawesome/pro-duotone-svg-icons'

export default defineNuxtComponent({
  props: {
    active: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    selectedDuration: {
      type: Object,
      required: true,
    },
  },

  emits: ['setActive'],

  data () {
    return {
      icons: {
        faCalendarClock,
      },
    }
  },

  computed: {
    displayDuration () {
      const d = this.selectedDuration
      const v = d?.value?.value || (!isNaN(d?.value) ? d?.value : null)
      const name = d?.value?.nameValue || d?.name || ''
      const dayOrDaysLabel = (min, max) => (min === max || !max)
        ? this.$t('charterSearchPeriodDay', min)
        : this.$t('charterSearchCustomDuration', [min, max])

      if (d?.value === 'custom' || d?.type === 'custom') {
        const [min, max] = d?.custom ?? []
        return dayOrDaysLabel(min, max)
      } else if (new RegExp(this.$t('label.days'), 'i').test(name)) {
        return dayOrDaysLabel(
          d?.value?.min || d?.value?.value,
          d?.value?.max || d?.value?.maxValue
        )
      } else if (new RegExp(`${this.$t('label.week')}|${this.$t('label.weeks')}`, 'i').test(name)) {
        return name
      } else if (v && !new RegExp('[a-zA-Z]').test(name)) {
        return name
          ? this.$t('charter.duration.week', { n: name })
          : this.$t('charterSearchPeriodDay', v)
      }

      return name
    },
  },
})
</script>
